"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFilesUpload = exports.useImagesUpload = exports.useUpload = exports.getRatiosMap = void 0;
const utils_1 = require("@obvio/utils");
const blurhash_1 = require("blurhash");
const react_1 = require("react");
const loadImage = (file) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = URL.createObjectURL(file);
        img.onerror = (...args) => reject(args);
        img.addEventListener('load', () => resolve(img));
    });
});
const getImageData = (image) => {
    const canvas = document.createElement('canvas');
    image.setAttribute('width', '512px');
    canvas.width = image.width;
    canvas.height = image.height;
    const context = canvas.getContext('2d');
    if (!context) {
        throw new Error("Context wasn't created");
    }
    context.drawImage(image, 0, 0);
    return context.getImageData(0, 0, image.width, image.height);
};
const encodeImageToBlurhash = (file) => __awaiter(void 0, void 0, void 0, function* () {
    const img = yield loadImage(file);
    const imageData = getImageData(img);
    return (0, blurhash_1.encode)(imageData.data, imageData.width, imageData.height, 4, 4);
});
function getRatiosMap(assets) {
    return assets.reduce((acc, img) => Object.assign(acc, { [img.name]: img.ratio }), {});
}
exports.getRatiosMap = getRatiosMap;
function useUpload(scope, getAsset, options) {
    const state = (0, react_1.useRef)(emptyUploadState());
    const registerAsset = (0, react_1.useCallback)((input) => {
        const { file } = input;
        const asset = getAsset(input);
        if (file instanceof Blob) {
            state.current.queue.push({ file, asset });
        }
        else {
            state.current.reservedNames.push(file.name);
        }
        return asset;
    }, [getAsset]);
    return (0, react_1.useCallback)((recordId, builder, onProgress, setFileNames) => __awaiter(this, void 0, void 0, function* () {
        const structure = yield builder(registerAsset);
        const { queue, reservedNames } = state.current;
        state.current = emptyUploadState();
        const uploads = [];
        const getUnique = (0, utils_1.uniqueNames)(reservedNames);
        const hashes = [];
        const fileNames = [];
        const fullScope = (options === null || options === void 0 ? void 0 : options.customScope)
            ? `${(0, utils_1.slugify)(scope)}${options.customScope}`
            : (0, utils_1.slugify)(scope);
        queue.forEach(({ file, asset }, i) => {
            const uniqueFile = getUnique(file);
            (0, utils_1.set)(asset, 'name', uniqueFile.name);
            fileNames.push(uniqueFile.name);
            setFileNames === null || setFileNames === void 0 ? void 0 : setFileNames(fileNames);
            uploads.push((0, utils_1.uploadBlob)(uniqueFile, `/api/uploadCMS/${fullScope}/${recordId}/${uniqueFile.name}`, (e) => onProgress === null || onProgress === void 0 ? void 0 : onProgress((0, utils_1.round)(((i + e.loaded / e.total) * 100) / uploads.length, 2), uniqueFile.name, (0, utils_1.round)((e.loaded / e.total) * 100, 2))).then((res) => {
                var _a;
                if (res.status >= 300) {
                    const msg = ((_a = res.responseData) === null || _a === void 0 ? void 0 : _a.error) || 'Upload failed';
                    throw new Error(msg);
                }
                return res;
            }));
            if (options === null || options === void 0 ? void 0 : options.generateHash) {
                hashes.push({ asset, cb: encodeImageToBlurhash(file) });
            }
        });
        setFileNames === null || setFileNames === void 0 ? void 0 : setFileNames(fileNames);
        const thumbs = yield Promise.all(hashes.map(({ cb }) => cb));
        thumbs.forEach((thumb, i) => (0, utils_1.set)(hashes[i].asset, 'thumb', thumb));
        yield Promise.all(uploads);
        return structure;
    }), [options === null || options === void 0 ? void 0 : options.customScope, options === null || options === void 0 ? void 0 : options.generateHash, registerAsset, scope]);
}
exports.useUpload = useUpload;
function emptyUploadState() {
    return { queue: [], reservedNames: [] };
}
function useImagesUpload(scope, options) {
    return useUpload(scope, (file) => ({
        name: file.file.name,
        ratio: file.ratio,
        thumb: file.thumb,
    }), Object.assign(Object.assign({}, options), { generateHash: true }));
}
exports.useImagesUpload = useImagesUpload;
function useFilesUpload(scope, options) {
    return useUpload(scope, (file) => ({
        name: file.file.name,
        src: '',
    }), options);
}
exports.useFilesUpload = useFilesUpload;
